module.exports = __webpack_public_path__ + "static/media/topic.14088728.png";